<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.89315 14.3617C7.99191 15.0787 8.59026 15.5481 9.31041 15.4863C10.0121 15.4261 10.5232 14.8799 10.4968 14.1382L10.2337 8.04087C10.1977 7.1883 9.47426 6.56215 8.551 6.64142C7.6462 6.71911 7.04011 7.4594 7.14996 8.30563L7.89315 14.3617ZM7.96598 18.2431C8.03891 19.0925 8.79926 19.7155 9.66712 19.641C10.535 19.5665 11.178 18.823 11.1051 17.9736C11.0306 17.1057 10.2766 16.5566 9.4087 16.6312C8.54083 16.7057 7.89147 17.3753 7.96598 18.2431Z"
      fill="white"
    />
    <path
      d="M12.7716 12.4613C12.7263 13.3661 13.1823 14.0961 14.1033 14.1833C15.0042 14.2687 15.5816 13.7174 15.7309 12.7821L16.827 6.5431C16.9895 5.46768 16.234 4.48709 15.0327 4.37328C13.8515 4.26137 12.9453 5.08452 12.8829 6.16942L12.7716 12.4613ZM12.0462 16.4933C11.9438 17.5744 12.6468 18.4692 13.7279 18.5716C14.789 18.6722 15.6457 17.9453 15.7481 16.8642C15.8486 15.8031 15.1104 15.0666 14.0493 14.966C12.9682 14.8636 12.1467 15.4322 12.0462 16.4933Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'Exclamations'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
